<script setup>
import { computed } from 'vue';
import { useFieldError } from 'vee-validate';

const props = defineProps({
  value: {
    type: [String, Number, null],
    required: false,
    default: null
  },

  name: {
    type: String,
    required: true
  },

  label: {
    type: String,
    required: true
  },

  validatorName: {
    type: String,
    required: false,
    default: null,
  },

  disabled: {
    type: Boolean,
    required: false,
    default: false
  },

  showRequiredIndicator: {
    type: Boolean,
    required: false,
    default: true
  },
});

const validatorNameWithFallback = computed(() => props.validatorName ?? props.label);

const fieldError = useFieldError(props.name);
</script>

<template>
  <div class="ce-passwordField">
    <validated-input
      :name="name"
      :validator-name="validatorNameWithFallback"
      :label="label"
      rules="required|password"
      type="password"
      autocomplete="off"
      autocapitalize="off"
      :disabled="disabled" />

    <validated-input
      :name="`${name}_confirmation`"
      :label="$t('validation.password.confirmationLabel', { fieldLabel: label })"
      :rules="`required|passwordconfirmation:@${name}`"
      type="password"
      autocomplete="off"
      autocapitalize="off"
      :disabled="disabled" />

    <div
      class="ce-passwordField-description"
      :class="{'ce-colorError': fieldError}">
      {{ $t('validation.password.criteriaMessage') }}
    </div>
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-passwordField {
  .ce-passwordField-description {
    margin: @space-3 0;
    .ms(-2);
    .line-height-3;

    &.ce-colorError {
      font-weight: bold;
    }
  }
}
</style>
